import React from 'react';
import Styles from './styles.js';
const Nabour = ({ title1, title2, details, imgsrc }) => {
  return (
    <>
      <div className="card bg-transparent border-0 pb-12">
        <img loading="lazy" src={imgsrc} className=" w-full h-full rounded-0 card-img-top " alt="..." />
        <div className="card-body p-0 pb-12">
          <div
            className="card-title flex lg:flex-row flex-col
             justify-between mt-4 mb-0 md:mb-1 pb-0 pb-md-1 pt-2"
            style={{ fontFamily: 'josefin Sans', color: '#F7F7F7' }}>
            <div>
              <h5 className="fs-24-res font-normal lg:pr-4">{title1}</h5>
            </div>

            <div>
              <h5 className="fs-16-18 font-normal lg:text-right">{title2}</h5>
            </div>
          </div>

          <p className="card-text font-normal fs-30-res lh-base  " style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
            <p className="mt-1 fs-30-res">{details}</p>
          </p>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default Nabour;
